// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { AccountType } from '@interfaces/user.interfaces';
import { NavService } from '@services/nav.service';
import { UserService } from '@services/user.service';
import { takeWhile } from 'rxjs';
import { tenantIsStellantis } from 'src/app/utils/utils';

@Component({
    selector: 'buyer-dashboard',
    templateUrl: './buyer-dashboard.component.html',
    styleUrls: ['./buyer-dashboard.component.scss'],
})
export class BuyerDashboardComponent implements OnInit, OnDestroy {
    private isComponentAlive = true;
    public showBreadcrumbs = false;
    public hideSideNav = false;
    public hideFooter = false;
    public versionNumber: string = null;
    public isUpload = false;

    constructor(
        private readonly router: Router,
        private readonly navService: NavService,
        private readonly userService: UserService,
        private readonly route: ActivatedRoute
    ) {
        if (window.location.href.includes('/upload')) {
            this.isUpload = true;
        } else {
            this.isUpload = false;
        }
        this.hideSideNav = window.innerWidth < 1200 ? true : false;
        this.navService.accountType = tenantIsStellantis() ? AccountType.stellantisBuyer : AccountType.ddjBuyer;
    }

    @HostListener('window:resize', ['$event'])
    onResize() {
        this.hideSideNav = window.innerWidth < 1200 ? true : false;
    }

    ngOnInit(): void {
        // get most recent version number from resolver for footer
        const version = (this.route.snapshot.data.version || []) as { versionNumber: string }[];
        if (version.length > 0) {
            this.versionNumber = version[0].versionNumber;
        }
        // need to check when page is refreshed
        this.hideFooter = window.location.pathname.includes('/sign');

        // set selected nav item
        const url: string[] = window.location.pathname.split('/').splice(2);
        this.navService.setSelectedRouteByURL(url[0]);

        this.router.events.pipe(takeWhile(() => this.isComponentAlive)).subscribe((navEvent) => {
            if (navEvent instanceof NavigationEnd) {
                const url: string[] = navEvent.url.split('/').splice(2);
                this.navService.setSelectedRouteByURL(url[0]);
            }

            if (navEvent instanceof NavigationEnd && navEvent.url.includes('main')) {
                const element = document.querySelector('.content');
                element.scrollTo(0, 0);
            }

            // need to check when router events fire, not just on load of dashboard
            if (navEvent instanceof NavigationEnd && navEvent.url.includes('sign')) {
                this.hideFooter = window.location.pathname.includes('/sign');
            }
        });

        this.userService.checkAndHandleMissingSignature();
    }

    ngOnDestroy(): void {
        this.isComponentAlive = false;
    }
}
